module.exports = __webpack_public_path__ + "img/upgrade.cf8cf536.png";